(function ($) {
  $(document).ready(function ($) {
    //console.log("theme.js initialization");
    var inHeight = window.innerHeight / 100;
    var inHeight2 = window.innerHeight / 100;
    var navheight = $("#notification-msg").outerHeight(true) + $("header").outerHeight(true);

    document.documentElement.style.setProperty("--vh", inHeight + "px");
    document.documentElement.style.setProperty("--vhm", inHeight2 + "px");
    document.documentElement.style.setProperty("--navHeight", navheight + "px");

    $(window).resize(function (event) {
      inHeight2 = window.innerHeight / 100;
      document.documentElement.style.setProperty("--vhm", inHeight2 + "px");
      document.documentElement.style.setProperty("--navHeight", navheight + "px");
    });

    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    /*****************************************************************
      Touch fix for devices to mimick hover effects
    ******************************************************************/
    $("*")
      .on("touchstart", function () {
        $(this).trigger("hover");
      })
      .on("touchend", function () {
        $(this).trigger("hover");
      });

    /*****************************************************************
      Scroll from top add class to the body for the nav
    ******************************************************************/
    $(window).scroll(function () {
      if ($(window).scrollTop() > 50) {
        $("body").addClass("scrolled");
      } else {
        $("body").removeClass("scrolled");
      }
    });

    /*****************************************************************
      Animation Library / Area.
      GSAP + GSAP ScrollTrigger
    ******************************************************************/
    gsap.registerPlugin(ScrollTrigger);

    // GSAP Custom Parallax
    gsap.utils.toArray("[data-gsap]").forEach((el) => {
      const obj = eval("(" + el.dataset.gsap + ")");
      // Scroll Options
      const scrollProps = {
        scrollTrigger: {
          start: "top bottom",
          end: "bottom top",
          trigger: el,
          scrub: 0.25, // Sets a 0.5 second delay, true is default for scrub
          //markers: true,
        },
      };
      // Add values to object from element data attribute
      Object.assign(scrollProps, obj);

      gsap.to(el, scrollProps);
    });

    // Scroll into view section animations
    gsap.utils.toArray(".fade-in-up").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 85%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          //markers: true,
        },
      });
    });

    gsap.utils.toArray(".fade-in-up-once").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 85%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          // onEnter: ({progress, direction, isActive}) => {
          //   if (isActive) {
          //     $(el).addClass("show");
          //   }
          // },
          //markers: true,
        },
      });
    });

    gsap.utils.toArray(".fade-in").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 80%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          //markers: true,
        },
      });
    });

    gsap.utils.toArray(".fade-in-once").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 85%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          //markers: true,
        },
      });
    });

    gsap.utils.toArray(".line-reveal").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 85%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          //markers: true,
        },
      });
    });

    /*****************************************************************
     * Scroll Down to next section quick script
     *****************************************************************/
    if ($(".scroll-down").length) {
      $(".scroll-down").click(function (e) {
        e.preventDefault();
        var nextSection = $(this).parent().closest(".shopify-section").next();

        $("html, body").animate(
          {
            scrollTop: nextSection.offset().top + 1,
          },
          800,
          function () {
            // window.location.hash = hash;
          }
        );
      });
    }

    /*****************************************************************
     * Smooth scroll for anchor links
     *****************************************************************/
    $('a[href^="#"]').click(function (e) {
      var target = $(this.getAttribute("href"));

      if (target.length) {
        e.preventDefault();
        var offset = $("#shopify-section-navigation").outerHeight(true);

        $("html, body").animate(
          {
            scrollTop: target.offset().top - offset,
          },
          800
        );
      }
    });

    /*****************************************************************
      Klaviyo form integration (footer)
    *****************************************************************/
    function KlaviyoSubscribe(listID, email, source) {
      var subscribed = false;
      $.ajax({
        type: "POST",
        url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        data: {
          g: listID,
          $fields: "$source, $consent, $email, Accepts Marketing",
          email: email,
          $consent: ["email"],
          //pass in additional fields
          //$fields: "$source, $first_name, $last_name",
          AcceptsMarketing: true,
          $source: source,
        },
        contentType: "application/x-www-form-urlencoded",
        error: function (err) {
          console.log("Could not connect to Klaviyo.");
          console.log(err);
        },
        success: function (res) {
          console.log("success");
          console.log(res);
          subscribed = true;

          if (res.data.is_subscribed == false) {
            $("#footer-klaviyo").remove();
            $("#footer-klaviyo-message p").text(klaviyoMsg);
          }

          if (res.data.is_subscribed == true) {
            klaviyoMsg = "That email is already subscribed to our list!";
            $("#footer-klaviyo").remove();
            $("#footer-klaviyo-message p").text(klaviyoMsg);
          }
        },
        async: false,
      });
      return subscribed;
    }

    $("#subscribe-to-newsletter").click(function (event) {
      event.preventDefault();
      const listID = $("#footer-klaviyo").data("klaviyoid");
      const email = $("#footer-subscribe").val();
      const source = "Nocsprovisions.com - General Newsletter singup, from footer";
      console.log(listID, email, source);
      if (email != "") {
        KlaviyoSubscribe(listID, email, source);
      } else {
        // do nothing
      }
    });
    /*****************************************************************
      END Klaviyo form integration
    *****************************************************************/

    /*****************************************************************
      Carousels Used site-wide
    *****************************************************************/

    // Featured Products Slider
    // ---
    var $featuredProducts = $(".featured-products-slider .owl-carousel");
    $featuredProducts.each(function (index, el) {
      $(el).owlCarousel({
        lazyLoad: true,
        autoWidth: true,
        items: 1,
        nav: false,
        dots: false,
        responsive: {
          767: {
            items: 3,
          },
          1000: {
            items: 4,
            nav: true,
            navText: [
              '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none"><path d="M1.11341 11.6117C0.572529 11.0708 0.572529 10.1938 1.11341 9.65296L9.92764 0.838737C10.4685 0.297852 11.3455 0.297852 11.8864 0.838737C12.4272 1.37962 12.4272 2.25657 11.8864 2.79745L4.05149 10.6323L11.8864 18.4672C12.4272 19.0081 12.4272 19.885 11.8864 20.4259C11.3455 20.9668 10.4685 20.9668 9.92764 20.4259L1.11341 11.6117ZM53.4146 12.0173L2.09277 12.0173L2.09277 9.2473L53.4146 9.2473L53.4146 12.0173Z" fill="#231F20"/></svg>',
              '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none"><path d="M52.7328 11.6117C53.2737 11.0708 53.2737 10.1938 52.7328 9.65296L43.9186 0.838737C43.3777 0.297852 42.5007 0.297852 41.9598 0.838737C41.4189 1.37962 41.4189 2.25657 41.9598 2.79745L49.7947 10.6323L41.9598 18.4672C41.4189 19.0081 41.4189 19.885 41.9598 20.4259C42.5007 20.9668 43.3777 20.9668 43.9186 20.4259L52.7328 11.6117ZM0.431641 12.0173L51.7534 12.0173L51.7534 9.2473L0.431641 9.2473L0.431641 12.0173Z" fill="#231F20"/></svg>',
            ],
          },
        },
      });
    });
    // ---
    // END Featured Products Slider

    // Basic Product Grid Slider
    // ---
    var $basicGrid = $(".basic-product-carousel .owl-carousel");
    $basicGrid.each(function (index, el) {
      $(el).owlCarousel({
        lazyLoad: true,
        autoWidth: true,
        items: 1,
        dots: false,
        nav: true,
        rewindNav: true,
        rewind: true,
        navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none"><path d="M1.11341 11.6117C0.572529 11.0708 0.572529 10.1938 1.11341 9.65296L9.92764 0.838737C10.4685 0.297852 11.3455 0.297852 11.8864 0.838737C12.4272 1.37962 12.4272 2.25657 11.8864 2.79745L4.05149 10.6323L11.8864 18.4672C12.4272 19.0081 12.4272 19.885 11.8864 20.4259C11.3455 20.9668 10.4685 20.9668 9.92764 20.4259L1.11341 11.6117ZM53.4146 12.0173L2.09277 12.0173L2.09277 9.2473L53.4146 9.2473L53.4146 12.0173Z" fill="#231F20"/></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none"><path d="M52.7328 11.6117C53.2737 11.0708 53.2737 10.1938 52.7328 9.65296L43.9186 0.838737C43.3777 0.297852 42.5007 0.297852 41.9598 0.838737C41.4189 1.37962 41.4189 2.25657 41.9598 2.79745L49.7947 10.6323L41.9598 18.4672C41.4189 19.0081 41.4189 19.885 41.9598 20.4259C42.5007 20.9668 43.3777 20.9668 43.9186 20.4259L52.7328 11.6117ZM0.431641 12.0173L51.7534 12.0173L51.7534 9.2473L0.431641 9.2473L0.431641 12.0173Z" fill="#231F20"/></svg>',
        ],
        responsive: {
          767: {
            items: 3,
          },
        },
      });
    });
    // ---
    // END Basic Product Grid Slider

    // Box Column Slider
    // ---
    var $boxColumns = $(".box-column-steps .owl-carousel");
    $boxColumns.each(function (index, el) {
      $(el).owlCarousel({
        lazyLoad: true,
        items: 1,
        autoHeight: true,
        dots: false,
        nav: true,
        navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none"><path d="M1.11341 11.6117C0.572529 11.0708 0.572529 10.1938 1.11341 9.65296L9.92764 0.838737C10.4685 0.297852 11.3455 0.297852 11.8864 0.838737C12.4272 1.37962 12.4272 2.25657 11.8864 2.79745L4.05149 10.6323L11.8864 18.4672C12.4272 19.0081 12.4272 19.885 11.8864 20.4259C11.3455 20.9668 10.4685 20.9668 9.92764 20.4259L1.11341 11.6117ZM53.4146 12.0173L2.09277 12.0173L2.09277 9.2473L53.4146 9.2473L53.4146 12.0173Z" fill="#231F20"/></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none"><path d="M52.7328 11.6117C53.2737 11.0708 53.2737 10.1938 52.7328 9.65296L43.9186 0.838737C43.3777 0.297852 42.5007 0.297852 41.9598 0.838737C41.4189 1.37962 41.4189 2.25657 41.9598 2.79745L49.7947 10.6323L41.9598 18.4672C41.4189 19.0081 41.4189 19.885 41.9598 20.4259C42.5007 20.9668 43.3777 20.9668 43.9186 20.4259L52.7328 11.6117ZM0.431641 12.0173L51.7534 12.0173L51.7534 9.2473L0.431641 9.2473L0.431641 12.0173Z" fill="#231F20"/></svg>',
        ],
      });
    });
    // ---
    // END Box Column Slider

    // Imagery Slider
    // ---
    var $imagerySlider = $(".imagery-slider .owl-carousel");
    $imagerySlider.each(function (index, el) {
      $(el).owlCarousel({
        autoWidth: true,
        loop: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 6500,
        lazyLoad: true,
      });
    });
    // ---
    // END Imagery Slider

    // How To Use Carousel
    // ---
    var $howToUse = $(".how-to-carousel .owl-carousel");
    $howToUse.each(function (index, el) {
      $(el).owlCarousel({
        lazyLoad: true,
        items: 1,
        dots: false,
        nav: true,
        rewindNav: true,
        rewind: true,
        navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none"><path d="M1.11341 11.6117C0.572529 11.0708 0.572529 10.1938 1.11341 9.65296L9.92764 0.838737C10.4685 0.297852 11.3455 0.297852 11.8864 0.838737C12.4272 1.37962 12.4272 2.25657 11.8864 2.79745L4.05149 10.6323L11.8864 18.4672C12.4272 19.0081 12.4272 19.885 11.8864 20.4259C11.3455 20.9668 10.4685 20.9668 9.92764 20.4259L1.11341 11.6117ZM53.4146 12.0173L2.09277 12.0173L2.09277 9.2473L53.4146 9.2473L53.4146 12.0173Z" fill="#231F20"/></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="21" viewBox="0 0 54 21" fill="none"><path d="M52.7328 11.6117C53.2737 11.0708 53.2737 10.1938 52.7328 9.65296L43.9186 0.838737C43.3777 0.297852 42.5007 0.297852 41.9598 0.838737C41.4189 1.37962 41.4189 2.25657 41.9598 2.79745L49.7947 10.6323L41.9598 18.4672C41.4189 19.0081 41.4189 19.885 41.9598 20.4259C42.5007 20.9668 43.3777 20.9668 43.9186 20.4259L52.7328 11.6117ZM0.431641 12.0173L51.7534 12.0173L51.7534 9.2473L0.431641 9.2473L0.431641 12.0173Z" fill="#231F20"/></svg>',
        ],
        responsive: {
          767: {
            mouseDrag: false,
          },
        },
      });
    });
    // ---
    // END How To Use Carousel

    /*****************************************************************
      END – Carousels Used site-wide
    *****************************************************************/

    /*****************************************************************
      Photo Rig Support phone model selector logic
    *****************************************************************/
    if ($(".support-select").length) {
      const selectElement = document.querySelector(".support-select");

      // Select the first item by default
      const firstOption = selectElement.options[0].value;

      // Set the first content to display based on the first option
      document.querySelectorAll(".support-content").forEach(function (content) {
        content.style.display = "none";
      });
      const firstContent = document.querySelector(`.support-content[data-model="${firstOption}"]`);
      if (firstContent) {
        firstContent.style.display = "block";
      }

      // Update content on change
      selectElement.addEventListener("change", function () {
        const selectedModel = this.value;

        // Hide all content divs
        document.querySelectorAll(".support-content").forEach(function (content) {
          content.style.display = "none";
        });

        // Show the content corresponding to the selected model
        const selectedContent = document.querySelector(`.support-content[data-model="${selectedModel}"]`);
        if (selectedContent) {
          selectedContent.style.display = "block";
        }
      });
    }
    /*****************************************************************
      END – Photo Rig Support phone model selector logic
    *****************************************************************/

    /*****************************************************************
      Events Overview Sibling Fade
    *****************************************************************/
    if ($(".events-grid").length) {
      var $eventItems = $(".events-grid .container").children();
      $eventItems.mouseenter(function () {
        $eventItems.not(this).addClass("sibling-fade");
      });
      $eventItems.mouseleave(function () {
        $eventItems.removeClass("sibling-fade");
      });
    }
    /*****************************************************************
      END – Events Overview Sibling Fade
    *****************************************************************/

    /*****************************************************************
      Regional / locale selector dropdown in the footer
    *****************************************************************/
    // Get the current URL
    var currentURL = new URL(window.location.href);
    if (currentURL.href == "http://127.0.0.1:9292/") {
      currentURL = new URL("https://www.nocsprovisions.com/");
    }

    $(".region-wrap").click(function (event) {
      var submenu = $(this).children("ul");
      if ($(submenu).hasClass("show")) {
        $(submenu).removeClass("show");
      } else {
        $(submenu).addClass("show");
      }
    });

    // Loop through each <li> element to find the matching URL
    $(".region-wrap ul li").each(function () {
      var listItem = $(this);
      var anchor = listItem.find("a");
      var anchorURL = anchor.attr("href").toString();

      // Check if the URL matches
      if (currentURL.href.includes(anchorURL)) {
        // Extract the region and flag spans
        var regionSpan = listItem.find(".region").clone();
        var flagSpan = listItem.find(".flag").clone();

        // Append them to the current-region div
        $(".current-region").append(regionSpan).append(flagSpan);

        // Remove the original <li> element
        listItem.remove();

        var regionHeight = $(".region-wrap").outerHeight(true);
        var adjustedRegionHeight = regionHeight - 8;
        $(".region-wrap ul").css("top", adjustedRegionHeight);

        // Exit the loop
        return false;
      } else {
        //console.log('inside falsey for .region-wrap');
      }
    });
    /*****************************************************************
      END – Regional / locale selector dropdown in the footer
    *****************************************************************/
  }); // end .ready()
})(jQuery);
